export default process.env.REACT_APP_SUBDIR_MODE === 'true';
